export const TWENTY_FOUR_HOURS_MS = 24 * 60 * 60 * 1000;

const DISMISSAL_KEY_PREFIX = 'attention_item_dismissed:';

function dismissalKey(id: string) {
  return `${DISMISSAL_KEY_PREFIX}${id}`;
}

export function isItemDismissed(id: string) {
  const dismissedAt = localStorage.getItem(dismissalKey(id));
  if (!dismissedAt) return false;
  return Date.now() - Number(dismissedAt) < TWENTY_FOUR_HOURS_MS;
}

export function dismissItem(id: string) {
  localStorage.setItem(dismissalKey(id), Date.now().toString());
}
